<div class="modal-news" #modalNews>
  <div class="header">
    <mat-icon class="icon-news align-bottom" svgIcon="news"></mat-icon>{{title}}
    <mat-icon class="close-btn" svgIcon="close" (click)="close()"></mat-icon>
  </div>
  <div [@valueListAnimation]="typeNews === 0 ? 'grid' : 'card'" class="row row-list" *ngIf="isList === 1 && !loading">
    <!-- FILTRO -->
    <div class="col-12 col-filter" [ngClass]="{'bg-single': whiteLabel === 2 || whiteLabel === 3}">
      <div class="row row-filter">
        <div class="col-3 col-search">
          <mat-form-field>
            <input (keyup)="keyUpSearch($event)" matInput placeholder="pesquisar notícia" [(ngModel)]="textFilter">
            <mat-icon matSuffix class="icon-search-input" svgIcon="search"></mat-icon>
          </mat-form-field>
        </div>
        <div class="col-2 col-agency">
          <mat-form-field>
            <mat-select id="mat-select-agency" placeholder="agência" [(ngModel)]="agencyFilter">
              <mat-option *ngFor="let item of listAgencys" value="{{item.value}}">{{item.desc}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-4 col-datepicker">
          <span class="label">selecione o período desejado</span>
          <ngbd-datepicker-range [maxDateToday]='true' [minOneYear]="true" id="datepicker" class="modal-datepicker"
            [reset]="changingValue" [startEmpty]='false' (dateIni)="changeDateIni($event)"
            (dateFin)="changeDateFim($event)"></ngbd-datepicker-range>
          <!-- [reset]="changingValue" -->
        </div>
        <div class="col-3 col-btn-filter">
          <button mat-raised-button class="xs" id="btn-clear" (click)="clearFilter()">LIMPAR</button>
          <button mat-raised-button class="xs white" id="btn-search" (click)="getNews()">FILTRAR</button>
        </div>
      </div>
    </div>
    <div class="col-12 col-icons-type" *ngIf="listNews?.length > 0">
      <mat-icon class="icon-grid" class="icon-list" [ngClass]="{'icon-active': typeNews === 1}" id="icon-list"
        (click)="toggleType(1)">
        dehaze</mat-icon>
      <mat-icon svgIcon="grid" class="icon-grid" [ngClass]="{'icon-active': typeNews === 0}" id="icon-grid"
        (click)="toggleType(0)">
      </mat-icon>
    </div>
    <div *ngIf="loadingSearch" class="spinner-search">
      <app-spinner-loading></app-spinner-loading>
    </div>
    <div class="col-12 adjust-overflow empty-news" *ngIf="!loading && !loadingSearch && listNews?.length === 0">
      <app-empty-result></app-empty-result>
    </div>
    <!-- Linha -->
    <div [@valueAnimationCards]="'card'" *ngIf="typeNews === 1 && !loadingSearch && listNews?.length > 0"
      class="col-12 adjust-overflow">
      <div class="col-12 col-cards">
        <div class="row">
          <div [@valueAnimation]="item" class="col-12 col-item"
            *ngFor="let item of (listNews | slice: (page - 1) * cardsPage : page * cardsPage)">
            <app-news-grid [data]="item" (dataDetail)="openDetails($event, true)"></app-news-grid>
          </div>
        </div>
      </div>
      <div class="col-12 div-pag" *ngIf="!loading && listNews?.length > 0">
        <div class="div-center">
          <button class="btn-pag pag-back-forward margin-right-10" (click)="changePage('back')">ANTERIOR</button>
          <button class="btn-pag pag-number margin-right-10" [ngClass]="{'selected' : item === page}"
            *ngFor="let item of listPages; let i = index" (click)="changePage(item)">{{item}}</button>
          <button class="btn-pag pag-back-forward" (click)="changePage('next')">PRÓXIMO</button>
        </div>
      </div>
    </div>
    <!-- Quadrado -->
    <div (scroll)="scrollEvent($event)" id="col-overflow" [@valueAnimationCards]="'grid'"
      *ngIf="typeNews === 0 && !loadingSearch && listNews?.length > 0" class="col-12 col-cards-overflow">
      <div class="row">
        <div class="col-12 col-item" id="col-card-scroll">
          <ngx-masonry [options]="myOptions">
            <!-- <ngxMasonryItem class="masonry-item" *ngFor="let item of (listNews | slice: 0 : nResize * cardsScroll)"> -->
            <ngxMasonryItem class="masonry-item" *ngFor="let item of (listNews)">
              <app-news-card [data]="item" (dataDetail)="openDetails($event, true)"></app-news-card>
            </ngxMasonryItem>
          </ngx-masonry>
        </div>
      </div>
    </div>
    <div *ngIf="loadingGet" class="spinner-get">
      <app-spinner-loading></app-spinner-loading>
    </div>
  </div>
  <div *ngIf="loading" class="spinner">
    <app-spinner-loading></app-spinner-loading>
  </div>
  <div *ngIf="isList === 0" [@valueLDetailAnimation]="'true'">
    <!-- <mat-icon svgIcon="goback" class="icon-details" (click)="openDetails()" (click)="openList()"></mat-icon> -->
    <app-news-detail [data]="selectedItem" (closeDetail)="openList()"></app-news-detail>
  </div>
</div>
